import React, { FC } from 'react';

import TestCard from '~/blocks/TestCard/TestCard';
import { RadioQuestionProps } from '~/components/Test/types';
import { ALPHABET } from '~/pages/const';

const RadioQuestion: FC<RadioQuestionProps> = ({
  onSelect,
  isCorrectByIdMap,
  selectedAnswersIds,
  submitted,
  answers,
  colorsMode,
}) => {
  return answers?.map((answer, i) => {
    const isCorrect = isCorrectByIdMap?.[answer?.id || ''];
    const selected = selectedAnswersIds?.includes(answer?.id || '');

    return (
      <TestCard.SmallAnswer
        key={answer?.id}
        data-testid="quizQuestionAnswer"
        selected={!!selected}
        onClick={() => onSelect(answer?.id)}
        passed={submitted && selected && isCorrect}
        failed={submitted && selected && !isCorrect}
        finished={submitted}
        colorsMode={colorsMode}
      >
        <TestCard.AnswerChar>{ALPHABET[i]}.</TestCard.AnswerChar>
        {answer?.title}
        {submitted && isCorrect && <TestCard.CorrectBadge />}
        {submitted && selected && !isCorrect && <TestCard.IncorrectBadge />}
      </TestCard.SmallAnswer>
    );
  });
};

export default RadioQuestion;
